module.exports = __webpack_public_path__ + "static/media/cereals.d5c0be19.jpg";